import { deserialize, fetchWrapper } from '../fetch';
import type { HomeData } from './interface';

export const fetchHome = async (): Promise<HomeData> => {
  const url = new URL('/app/v1/home', API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
